import {FC} from 'react'
import {ViewOrderLineItemsWrapper} from './lineItems/ViewOrderLineItemsWrapper'
import DeliveryMethodWrapper from './DeliveryMethodWrapper'
import PaymentWrapper from './PaymentSummary/PaymentWrapper'
import CustomerWrapper from './customer/CustomerWrapper'
import OrderHistoryWrapper from './OrderHistoryWrapper'
import CustomerNoteWrapper from 'app/features/orders/orderEdit/edit/components/note/CustomerNoteWrapper'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'
import {selectViewOrderNote, selectViewOrderNotes} from 'app/features/orders/redux/order/orderSlice'
import OrderTracking from './OrderTracking'
import FutureShipDate from './FutureShipDate/FutureShipDate'

type Props = {}

const OrderViewWrapper: FC<Props> = () => {
  const note = useSelector<RootState, any>(selectViewOrderNote)
  const notes = useSelector<RootState, any[]>(selectViewOrderNotes)
  return (
    <div className='row gy-5 g-xl-8'>
      <div className='col-xl-8'>
        <ViewOrderLineItemsWrapper />
        <PaymentWrapper />
        <CustomerNoteWrapper note={note} notes={notes} />
      </div>
      <div className='col-xl-4'>
        <CustomerWrapper />
        <FutureShipDate />
        <DeliveryMethodWrapper />
        <OrderTracking />
        <OrderHistoryWrapper />
      </div>
    </div>
  )
}

export default OrderViewWrapper
